module.exports = __webpack_public_path__ + "static/media/pic_03.9d846d3d.png";